<template>
  <div>
    <validate-mess :list="validateList" v-transition></validate-mess>
  </div>
</template>

<script>
import ValidateMess from './components/Mess'
export default {
  name: 'Revisepaywordvalidate',
  components: {
    ValidateMess
  },
  data () {
    return {
      validateList: {}
    }
  },
  methods: {
    getValidateInfo () {
      this.axios.get('/ApiMe/GetUpdatePaypassword')
        .then(this.getValidateInfoSucc)
        .catch(this.getValidateInfoFail)
    },
    getValidateInfoSucc (res) {
      res = res.data
      if (res.ret && res.data) {
        const data = res.data
        this.validateList = JSON.parse(data.validateList)
      }
    },
    getValidateInfoFail () {
      alert('获取数据失败')
    }
  },
  mounted () {
    this.getValidateInfo()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/revise_logon_password_validate/Validate.vue